import patchSafari from "./patch.js";

patchSafari()

export { gunAvatar } from './main'
export { parsePub } from './pub'
export { mountClass, mountElement } from './mount'
export { extractFromFile, error } from './embed'